import qs from 'qs';
import { useMemo } from 'react';

import { allFixPlanOptionKeys } from '../../../../shared/reports';
import { useQuery } from '../../../contexts/RouterContext';
import { buildFixPlanParams } from '../../projects/generic/ReportGenerationV2/shared/utils';
import type { ReportsV3QueryParams } from '../types';

/**
 * Reads fix plan option keys from URL query params and converts them to the
 * backend query string format using `buildFixPlanParams()`.
 *
 * URL params store values as strings (`'true'`), so we collect the keys whose
 * value is `'true'` into the include-list that `buildFixPlanParams` expects.
 */
export const useRemediationOptionsParams = (): string => {
  const [query] = useQuery<ReportsV3QueryParams>();

  return useMemo(() => {
    const includeOptions = allFixPlanOptionKeys.filter(
      (key) => (query as Record<string, string | undefined>)[key] === 'true',
    );
    const params = buildFixPlanParams(includeOptions);
    return qs.stringify(params);
  }, [query]);
};
